// extracted by mini-css-extract-plugin
module.exports = {"contactOptionsContainer":"styles_contactOptionsContainer__1OBa2","iconPencil":"styles_iconPencil__20PGv","iconBin":"styles_iconBin__141eI"};